import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Header } from '../../components/layout/Header';
import { Footer } from '../../components/layout/Footer';
import { Button } from '../../components/ui/Button';
import { Input } from '../../components/ui/Input';
import { Card, CardContent } from '../../components/ui/Card';
import { Badge } from '../../components/ui/Badge';
import { ProgressStepper } from '../../components/ui/ProgressStepper';
import { Search, ArrowLeft, MapPin, Calendar, Clock, AlertTriangle, FileText, CheckCircle2 } from 'lucide-react';
export function TrackLaporanPage() {
  const [ticketId, setTicketId] = useState('');
  const [searchStatus, setSearchStatus] = useState<'idle' | 'loading' | 'found' | 'not-found'>('idle');
  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    if (!ticketId.trim()) return;
    setSearchStatus('loading');
    // Simulate API call
    setTimeout(() => {
      if (ticketId.toLowerCase().includes('404')) {
        setSearchStatus('not-found');
      } else {
        setSearchStatus('found');
      }
    }, 1500);
  };
  // Mock data for result
  const reportData = {
    id: 'TKT-2025-8821',
    category: 'Tumpukan Sampah Liar',
    status: 'In Progress',
    date: '20 Feb 2025',
    location: 'Jl. Sudirman No. 45, Jakarta Pusat',
    description: 'Tumpukan sampah plastik dan organik di pinggir jalan mengganggu pejalan kaki dan menimbulkan bau tidak sedap.',
    steps: [{
      label: 'Laporan Diterima',
      date: '20 Feb 2025, 08:30',
      status: 'completed' as const
    }, {
      label: 'Verifikasi Petugas',
      date: '20 Feb 2025, 09:15',
      status: 'completed' as const
    }, {
      label: 'Penanganan',
      date: 'Sedang berlangsung',
      status: 'current' as const
    }, {
      label: 'Selesai',
      date: '-',
      status: 'upcoming' as const
    }]
  };
  return <div className="min-h-screen bg-gray-50 flex flex-col font-sans" data-id="element-5021">
      <Header data-id="element-5022" />

      <main className="flex-1" data-id="element-5023">
        {/* Hero Search Section */}
        <section className="bg-primary-700 text-white py-16" data-id="element-5024">
          <div className="container mx-auto px-4 md:px-6 text-center max-w-2xl" data-id="element-5025">
            <h1 className="text-3xl font-bold mb-4" data-id="element-5026">Lacak Status Laporan</h1>
            <p className="text-primary-100 mb-8" data-id="element-5027">
              Masukkan nomor tiket laporan Anda untuk mengetahui progress
              penanganan terkini.
            </p>

            <Card className="bg-white p-2 shadow-xl border-0" data-id="element-5028">
              <form onSubmit={handleSearch} className="flex flex-col sm:flex-row gap-2" data-id="element-5029">
                <div className="relative flex-1" data-id="element-5030">
                  <Search className="absolute left-3 top-3 h-5 w-5 text-gray-400" data-id="element-5031" />
                  <Input placeholder="Contoh: TKT-2025-8821" className="pl-10 h-12 border-0 bg-gray-50 focus:ring-0 text-gray-900 placeholder:text-gray-400" value={ticketId} onChange={e => setTicketId(e.target.value)} data-id="element-5032" />
                </div>
                <Button type="submit" className="h-12 px-8 bg-primary-600 hover:bg-primary-700 text-white font-semibold" disabled={searchStatus === 'loading'} data-id="element-5033">
                  {searchStatus === 'loading' ? 'Mencari...' : 'Lacak Laporan'}
                </Button>
              </form>
            </Card>
          </div>
        </section>

        {/* Result Section */}
        <section className="py-12 container mx-auto px-4 md:px-6 max-w-4xl" data-id="element-5034">
          {searchStatus === 'idle' && <div className="text-center text-gray-500 py-12" data-id="element-5035">
              <FileText className="h-16 w-16 mx-auto mb-4 opacity-20" data-id="element-5036" />
              <p data-id="element-5037">Silakan masukkan nomor tiket untuk melihat detail laporan.</p>
            </div>}

          {searchStatus === 'not-found' && <div className="text-center py-12 animate-in fade-in" data-id="element-5038">
              <div className="h-16 w-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-5039">
                <AlertTriangle className="h-8 w-8 text-red-600" data-id="element-5040" />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-5041">
                Laporan Tidak Ditemukan
              </h3>
              <p className="text-gray-600 mb-6" data-id="element-5042">
                Nomor tiket{' '}
                <span className="font-mono font-bold" data-id="element-5043">{ticketId}</span> tidak
                terdaftar dalam sistem kami. Mohon periksa kembali nomor tiket
                Anda.
              </p>
              <Button variant="outline" onClick={() => setSearchStatus('idle')} data-id="element-5044">
                Coba Lagi
              </Button>
            </div>}

          {searchStatus === 'found' && <div className="space-y-6 animate-in slide-in-from-bottom-4 duration-500" data-id="element-5045">
              {/* Header Info */}
              <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4 mb-6" data-id="element-5046">
                <div data-id="element-5047">
                  <div className="flex items-center gap-3 mb-1" data-id="element-5048">
                    <h2 className="text-2xl font-bold text-gray-900 font-mono" data-id="element-5049">
                      {reportData.id}
                    </h2>
                    <Badge className="bg-yellow-100 text-yellow-700 border-yellow-200" data-id="element-5050">
                      Diproses
                    </Badge>
                  </div>
                  <p className="text-gray-500 text-sm" data-id="element-5051">
                    Dilaporkan pada {reportData.date}
                  </p>
                </div>
                <Link to="/lapor-isu" data-id="element-5052">
                  <Button variant="outline" size="sm" data-id="element-5053">
                    <ArrowLeft className="h-4 w-4 mr-2" data-id="element-5054" /> Buat Laporan Baru
                  </Button>
                </Link>
              </div>

              {/* Progress Stepper */}
              <Card className="overflow-hidden" data-id="element-5055">
                <div className="bg-gray-50 p-4 border-b border-gray-100" data-id="element-5056">
                  <h3 className="font-semibold text-gray-900" data-id="element-5057">
                    Status Penanganan
                  </h3>
                </div>
                <CardContent className="p-8" data-id="element-5058">
                  <ProgressStepper steps={['Laporan Diterima', 'Verifikasi Petugas', 'Penanganan', 'Selesai']} currentStep={3} data-id="element-5059" />
                </CardContent>
              </Card>

              {/* Detail Info */}
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-5060">
                <Card className="md:col-span-2" data-id="element-5061">
                  <CardContent className="p-6 space-y-6" data-id="element-5062">
                    <div data-id="element-5063">
                      <h3 className="text-sm font-medium text-gray-500 mb-1" data-id="element-5064">
                        Kategori Isu
                      </h3>
                      <p className="text-lg font-semibold text-gray-900 flex items-center gap-2" data-id="element-5065">
                        <AlertTriangle className="h-5 w-5 text-orange-500" data-id="element-5066" />
                        {reportData.category}
                      </p>
                    </div>

                    <div data-id="element-5067">
                      <h3 className="text-sm font-medium text-gray-500 mb-1" data-id="element-5068">
                        Lokasi
                      </h3>
                      <p className="text-gray-900 flex items-start gap-2" data-id="element-5069">
                        <MapPin className="h-5 w-5 text-gray-400 mt-0.5 flex-shrink-0" data-id="element-5070" />
                        {reportData.location}
                      </p>
                    </div>

                    <div data-id="element-5071">
                      <h3 className="text-sm font-medium text-gray-500 mb-1" data-id="element-5072">
                        Deskripsi
                      </h3>
                      <p className="text-gray-700 bg-gray-50 p-4 rounded-lg border border-gray-100" data-id="element-5073">
                        "{reportData.description}"
                      </p>
                    </div>

                    <div data-id="element-5074">
                      <h3 className="text-sm font-medium text-gray-500 mb-2" data-id="element-5075">
                        Foto Bukti
                      </h3>
                      <div className="h-48 w-full md:w-64 bg-gray-200 rounded-lg flex items-center justify-center overflow-hidden" data-id="element-5076">
                        {/* Placeholder image */}
                        <img src="https://images.unsplash.com/photo-1530587191325-3db32d826c18?auto=format&fit=crop&q=80&w=400" alt="Bukti Laporan" className="w-full h-full object-cover" data-id="element-5077" />
                      </div>
                    </div>
                  </CardContent>
                </Card>

                <Card className="h-fit" data-id="element-5078">
                  <div className="bg-blue-50 p-4 border-b border-blue-100" data-id="element-5079">
                    <h3 className="font-semibold text-blue-900 flex items-center gap-2" data-id="element-5080">
                      <CheckCircle2 className="h-4 w-4" data-id="element-5081" /> Catatan Petugas
                    </h3>
                  </div>
                  <CardContent className="p-4" data-id="element-5082">
                    <div className="space-y-4" data-id="element-5083">
                      <div className="relative pl-4 border-l-2 border-gray-200 pb-4" data-id="element-5084">
                        <div className="absolute -left-[5px] top-0 h-2.5 w-2.5 rounded-full bg-gray-300" data-id="element-5085"></div>
                        <p className="text-xs text-gray-500 mb-1" data-id="element-5086">
                          20 Feb, 09:15
                        </p>
                        <p className="text-sm text-gray-700" data-id="element-5087">
                          Laporan telah diverifikasi dan diteruskan ke Dinas
                          Lingkungan Hidup Jakarta Pusat.
                        </p>
                        <p className="text-xs font-medium text-gray-500 mt-1" data-id="element-5088">
                          - Admin Command Center
                        </p>
                      </div>
                      <div className="relative pl-4 border-l-2 border-blue-200" data-id="element-5089">
                        <div className="absolute -left-[5px] top-0 h-2.5 w-2.5 rounded-full bg-blue-500" data-id="element-5090"></div>
                        <p className="text-xs text-gray-500 mb-1" data-id="element-5091">
                          20 Feb, 10:30
                        </p>
                        <p className="text-sm text-gray-700" data-id="element-5092">
                          Tim Satgas Kebersihan sedang menuju lokasi untuk
                          peninjauan.
                        </p>
                        <p className="text-xs font-medium text-gray-500 mt-1" data-id="element-5093">
                          - Petugas Lapangan
                        </p>
                      </div>
                    </div>
                  </CardContent>
                </Card>
              </div>
            </div>}
        </section>
      </main>

      <Footer data-id="element-5094" />
    </div>;
}